// main.tsx
import ReactDOM from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";
import "./sentry.ts";
import { Toaster } from "./components/ui/sonner";
import { injectSpeedInsights } from "@vercel/speed-insights";
import { inject } from "@vercel/analytics";

const domain = import.meta.env.VITE_AUTH0_DOMAIN as string;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string;
injectSpeedInsights();
inject();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{ redirect_uri: window.location.origin }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <AuthProvider>
      <App />
      <Toaster />
    </AuthProvider>
  </Auth0Provider>
);
